<template>
  <div class="vaccinum-chart">
    <div class="vaccinum-chart-form">
      <van-form>
        <van-field
          readonly
          clickable
          name="datetimePicker"
          :value="`${moment(currentDate[0]).format('YYYY/MM/DD')}~${moment(currentDate[1]).format('YYYY/MM/DD')}`"
          label="时间选择"
          placeholder="点击选择时间"
          @click="showCalendar = true"
        />
        <van-calendar
          :min-date="new Date('2022-01-01')"
          :default-date="currentDate"
          type="range"
          allow-same-day
          v-model="showCalendar"
          @confirm="onDataConfirm"
        >
          <template slot="title">
            <div class="vaccinum-calendar-title">
              请选择时段
            </div>
            <div class="vaccinum-calendar-option">
              <el-button
                round
                size="mini"
                @click="selectDate('7days')"
              >最近7天</el-button>
              <el-button
                round
                size="mini"
                @click="selectDate('1months')"
              >最近1个月</el-button>
              <el-button
                round
                size="mini"
                @click="selectDate('3months')"
              >最近3个月</el-button>
              <el-button
                round
                size="mini"
                @click="selectDate('48')"
              >前4后8周</el-button>

            </div>

          </template>
        </van-calendar>
        <div class="vaccinum-chart-btn">
          <el-button
            type="primary"
            size="small"
            round
            @click="search"
            :loading="loading"
          >搜索</el-button>
        </div>
      </van-form>
    </div>
    <div class="vaccinum-chart-box">

    </div>
    <div class="vaccinum-chart-table">
      <el-table
        :data="tableData"
        height="100%"
        border
        style="width: 100%"
        size="small"
        row-key="appointmentNo"
      >
        <el-table-column
          prop="总容量"
          label="总容量"
          width="60px"
        >
        </el-table-column>
        <el-table-column
          prop="已约数量"
          label="已约数量"
          width="100px"
        >
        </el-table-column>
        <el-table-column
          prop="自助预约率"
          label="自助预约率"
          width="100px"
        >
          <template slot-scope="item">
            {{ ((item.row['自助预约数量'] / item.row['已约数量']) * 100).toFixed(2) }}%
          </template>
        </el-table-column>

        <el-table-column
          prop="首针预约率"
          label="首针预约率"
        >
          <template slot-scope="item">
            {{ ((item.row['首针预约数量'] / item.row['已约数量']) * 100).toFixed(2) }}%
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import * as echarts from "echarts";
import moment from "moment";
import hisService from "@/apis/his/index";
const keyMap = [
  "总容量",
  "已约数量",
  "自助预约数量",
  "首针预约数量",
  "自助预约率",
  "首针预约率",
];
let myChart = null;
export default {
  data() {
    return {
      showCalendar: false,
      form: {},
      tableData: [],
      loading: false,
      day: moment().format("YYYY-MM-DD"),
      currentDate: [moment().subtract(6, "days").toDate(), moment().toDate()],
    };
  },
  created() {},
  mounted() {
    myChart = echarts.init(document.querySelector(".vaccinum-chart-box"));

    this.getAppointmentInfo();
  },
  methods: {
    moment,
    search() {
      this.getAppointmentInfo();
    },
    getAppointmentInfo() {
      const { currentDate } = this;
      const params = {
        msg_type: "OutpatientDepartment.ChannelReservation.FindAppointmentInfo",
        logistics_interface: JSON.stringify({
          startTime: moment(currentDate[0]).format("YYYY-MM-DD"),
          endTime: moment(currentDate[1]).format("YYYY-MM-DD"),
          itemID: "5465",
        }),
      };
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      hisService.mainMethod(params).then((res) => {
        const totalData = {};
        const chartData = {
          xAxisData: [],
        };

        keyMap.forEach((key) => {
          totalData[key] = res.reduce(
            (accumulator, currentValue) => accumulator + currentValue[key],
            0
          );
          chartData[key] = [];
          chartData[key] = res.map((item) => item[key]);
        });

        res.forEach((item) => {
          chartData.xAxisData.push(moment(item["预约日期"]).format("MM/DD"));
        });

        this.tableData = [totalData];
        this.initChart(chartData);
        loading.close();
      });
    },
    selectDate(type) {
      if (type === "7days") {
        this.currentDate = [
          moment().subtract(6, "days").toDate(),
          moment().toDate(),
        ];
      } else if (type === "1months") {
        this.currentDate = [
          moment().subtract(1, "months").toDate(),
          moment().toDate(),
        ];
      } else if (type === "3months") {
        this.currentDate = [
          moment().subtract(3, "months").toDate(),
          moment().toDate(),
        ];
      } else if (type === "48") {
        this.currentDate = [
          moment().subtract(4, "weeks").toDate(),
          moment().add(8, "weeks").toDate(),
        ];
      }
      this.showCalendar = false;
    },
    initChart(data) {
      console.log(data);
      myChart.clear();
      myChart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "cross",
            crossStyle: {
              color: "#999",
            },
          },
        },
        // calculable: true,
        dataZoom: [
          {
            show: true,
            // start: 0,
            // end: 10,
            startValue: 0,
            endValue: 7,
          },
          {
            type: "inside",
            start: 94,
            end: 100,
          },
        ],
        legend: {
          type: "scroll",
          data: keyMap,
        },
        xAxis: [
          {
            type: "category",
            data: data.xAxisData,
            axisPointer: {
              type: "shadow",
            },
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "数量",
            // min: 0,
            // max: 250,
            // interval: 50,
            // axisLabel: {
            //   formatter: "{value} ml",
            // },
          },
          {
            type: "value",
            name: "比率",
            min: 0,
            max: 100,
            axisLabel: {
              formatter: "{value} %",
            },
          },
        ],
        series: [
          {
            name: "总容量",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            data: data["总容量"],
          },
          {
            name: "已约数量",
            type: "bar",
            tooltip: {
              valueFormatter: function (value) {
                return value;
              },
            },
            data: data["已约数量"],
          },
          {
            name: "自助预约率",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return `${value} %`;
              },
            },
            data: data["自助预约率"],
          },
          {
            name: "首针预约率",
            type: "line",
            yAxisIndex: 1,
            tooltip: {
              valueFormatter: function (value) {
                return `${value} %`;
              },
            },
            data: data["首针预约率"],
          },
        ],
      });
    },
    onDataConfirm(data) {
      this.currentDate = data;
      this.showCalendar = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.vaccinum-chart {
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .vaccinum-chart-box {
    flex: 1;
  }
  .van-calendar__header-title {
    height: 80px;
  }
}
.vaccinum-chart-btn {
  padding: 10px 20px;
  .el-button {
    width: 100%;
  }
}
.vaccinum-chart-table {
  height: 100px;
}
</style>
<style lang="scss">
.vaccinum-chart {
  .van-calendar__header-title {
    height: 80px;
    line-height: 16px;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  .vaccinum-calendar-option {
    display: flex;
    margin-top: 15px;
    .el-button {
      margin: 0 5px;
    }
  }
}
</style>